<template>
  <section class="technological">    
    <van-tabs background="#f8f8f8" color="#7ADFDF" title-inactive-color="#999" title-active-color="#333" swipeable v-model="active" @change='change'>
      <van-tab v-for="(item,index) in navDatas" :key="index" :title="item.blockName" v-if='item.type==20'>
        <div class="content">
          <!-- <img v-if='item.blockPic' :src="item.blockPic" align="middle" style='width:100%'/> -->
          <!-- <div v-else v-html="item.blockContent"></div> -->
        </div>
      </van-tab>
    </van-tabs>
  </section>
</template>

<script>
  export default {
    name: 'technological',
    data () {
      return {
        active : 0
      }
    },
    props: {
      navDatas: {
        type: Array,
        default: () => []
      }
    },
    watch: {},
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {
      change(){
        console.log(this.active)
      }

    }

  }
</script>

<style lang="scss" scoped>
.technological{
  
  .van-tab__pane{
    padding-top: 100px;
  }
  .content{
    width:100%;
    text-align: center;
    img{max-width: 100%}
  }
}
</style>
<style lang="scss">
  .technological{
    .van-hairline--top-bottom::after{
      border-width: 0;
    }
  }


 
 
</style>
